import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type {
  CollectingSiteAddressValidation,
  PostCollectingRequestValidateAddressParams,
  PostCollectingRequestValidateAddressResponse,
} from '~/types/delivery-agency.types';

const fetchPostCollectingRequestValidateAddress = async (
  params: PostCollectingRequestValidateAddressParams
): Promise<CollectingSiteAddressValidation> => {
  const { data } = await axiosInstance.post<PostCollectingRequestValidateAddressResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.POST_COLLECTING_REQUEST_VALIDATE_ADDRESS,
    params
  );
  return data.data;
};

export const usePostCollectingRequestValidateAddressMutation = () => {
  return useMutation<
    CollectingSiteAddressValidation,
    TypeErrorResponseData['error'],
    PostCollectingRequestValidateAddressParams
  >({
    mutationFn: fetchPostCollectingRequestValidateAddress,
    meta: { showGlobalErrorToast: false, showGlobalDimOverlay: false },
  });
};

registerMockAPI<PostCollectingRequestValidateAddressResponse>({
  method: 'post',
  endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_COLLECTING_REQUEST_VALIDATE_ADDRESS,
  label: '배송 주문 반품 신청·조회/반품 신청 회수지 주소 검증',
  scenarios: [
    {
      name: '회수 가능',
      response: { data: { available: true, unserviceableReason: '' } },
    },
    {
      name: '회수 불가',
      response: {
        data: {
          available: false,
          unserviceableReason:
            '회수 서비스 지역이 아닙니다.\n확인 후 다시 시도해주세요.\n입력한 주소: 경기도 화성시 병점구 화산로 2 (안녕동, 안녕초등학교)',
        },
      },
    },
  ],
});
